import Vue from 'vue';
import ZengaUsedProperty from './zenga-used-property/zenga-used-property.vue';
Vue.component('zenga-used-property', ZengaUsedProperty);
